import { OutcomeEvent } from "../scripts/outcomes.entities";


export class OutcomesDatatableEntry {
    Study: string;
    Appendix: string;
    Site: string;
    SiteNumber: string;
    Outcome: string;

    PotentialOutcomes: number;
    ExpectedOutcomes: number;
    Completed: number[] = [];
    Overdue: number[] = [];
    NotDone: number[] = [];
    DiscPrior: number[] = [];
    NotYetDue: number;

    CompletedOutcomes: OutcomeEvent[] = [];
    OverdueOutcomes: OutcomeEvent[] = [];
    NotDoneOutcomes: OutcomeEvent[] = [];
    DiscPriorOutcomes: OutcomeEvent[] = [];

    sortValue: number;

    constructor(study: string, appendix: string, site: string, siteNumber: string, outcome: string) {
        this.Study = study;
        this.Appendix = appendix;
        this.Site = site;
        this.SiteNumber = siteNumber;
        this.Outcome = outcome;

        this.PotentialOutcomes = 0;
        this.ExpectedOutcomes = 0;
        this.NotYetDue = 0;
    }

    addOutcomeEvent(outcome: OutcomeEvent): void {
        this.PotentialOutcomes += 1;

        switch (outcome.OutcomeStatusId) {
            case 1: this.Completed[0] = (this.Completed[0] == undefined) ? 1 : (this.Completed[0] + 1); this.ExpectedOutcomes += 1; this.CompletedOutcomes.push(outcome); break;
            case 2: this.DiscPrior[0] = (this.DiscPrior[0] == undefined) ? 1 : (this.DiscPrior[0] + 1); this.ExpectedOutcomes += 1; this.DiscPriorOutcomes.push(outcome); break;
            case 3: this.Overdue[0] = (this.Overdue[0] == undefined) ? 1 : (this.Overdue[0] + 1); this.ExpectedOutcomes += 1; this.OverdueOutcomes.push(outcome); break;
            case 4: this.NotDone[0] = (this.NotDone[0] == undefined) ? 1 : (this.NotDone[0] + 1); this.ExpectedOutcomes += 1; this.NotDoneOutcomes.push(outcome); break;
            case 5: this.NotYetDue = (this.NotYetDue == undefined) ? 1 : (this.NotYetDue + 1); break;
        }
    }

    initialize(): void {
        if (this.ExpectedOutcomes > 0) {
            if (this.Completed[0] != undefined) { this.Completed[1] = (this.Completed[0] / this.ExpectedOutcomes); }
            if (this.Overdue[0] != undefined) { this.Overdue[1] = (this.Overdue[0] / this.ExpectedOutcomes); }
            if (this.NotDone[0] != undefined) { this.NotDone[1] = (this.NotDone[0] / this.ExpectedOutcomes); }
            if (this.DiscPrior[0] != undefined) { this.DiscPrior[1] = (this.DiscPrior[0] / this.ExpectedOutcomes); }
        }
    }

    static addValue(currentValue: number, valueToAdd: number): number {
        if (currentValue == undefined) { currentValue = 0; }
        currentValue += valueToAdd;
        return currentValue;
    }

    static getHash(grouping: string, outcome: OutcomeEvent): string {
        if (grouping == "none") { return outcome.StudyId + "-" + outcome.AppendixId + "-" + outcome.SiteNumber + "-" + outcome.OutcomeId; }
        else if (grouping == "by-outcome") { return outcome.StudyId + "-" + outcome.AppendixId + "-" + outcome.OutcomeId; }
        else if (grouping == "by-site") { return outcome.StudyId + "-" + outcome.AppendixId + "-" + outcome.SiteNumber; }
        else return "unknown";
    }
}